import type { ApiResponse } from '../../api/contract';
import type { ReportKind } from '../reports/types';

type ExportListResponse = ApiResponse<'/api/v1/report-exports', 'get'>;

export type ReportExport = ExportListResponse['data'][number];
export type ReportExportDetail = ReportExport & { readonly requestId: string | null };
export type ReportExportStatus = ReportExport['status'];
export type ReportExportApiType = ReportExport['reportType'];
export type ReportExportFilters = Readonly<Record<string, string | number>>;

export interface CreateReportExportInput {
  readonly reportType: ReportKind;
  readonly filters: ReportExportFilters;
}

export interface ReportExportListFilters {
  readonly reportType: ReportKind | '';
  readonly status: ReportExportStatus | '';
  readonly requestedBy: string;
  readonly partnerId: string;
  readonly agentId: string;
  readonly from: string;
  readonly to: string;
}

export interface ReportExportListQuery {
  readonly cursor: string;
  readonly pageSize: number;
  readonly filters: ReportExportListFilters;
}

export const defaultReportExportListQuery = Object.freeze<ReportExportListQuery>({
  cursor: '',
  pageSize: 50,
  filters: {
    reportType: '',
    status: '',
    requestedBy: '',
    partnerId: '',
    agentId: '',
    from: '',
    to: '',
  },
});
